export const selectUnderwriting = ({ underwriting }) => underwriting;
